import { z } from 'zod';
import errors from './errors';

export const phoneSchema = (lang: 'en' | 'de', isRequired = true) =>
  z
    .string()
    .optional()
    .refine(
      (val) => {
        if (!isRequired && (!val || val.trim() === '')) return true;
        return /^\d+$/.test(val || '');
      },
      { message: errors.phone[lang] }
    );

export const otpSchema = (lang: 'en' | 'de') =>
  z.coerce.number().refine((value) => value >= 1000 && value <= 9999, {
    message: errors.otp[lang],
  });

export const passwordSchema = (lang: 'en' | 'de') =>
  z.string().refine(
    (value) => {
      return value.length >= 8;
    },
    {
      message: errors.password[lang],
    }
  );

export const confirmPasswordSchema = (lang: 'en' | 'de') =>
  z.string().refine(
    (value) => {
      return value.length >= 8;
    },
    {
      message: errors.password[lang],
    }
  );

export const emailSchema = z.string().email({ message: errors.email['de'] });

/**
 * This is a duplicate of emailSchema as function, it uses lang for localize message.
 *
 * @param lang string
 * @returns z
 */
export const getEmailSchema = (lang: 'en' | 'de' = 'de') => {
  return z.string().email({ message: errors.email[lang] });
};

export const email = (lang: 'en' | 'de') =>
  z.string().email({ message: errors.email[lang] });

export const password = (lang: 'en' | 'de') =>
  z.string().min(6, { message: errors.required[lang] });
export const confirmPassword = (message: string) =>
  z.string().min(8, { message });
export const phone = (message: string) => z.string().regex(/^\d+$/, message);
export const otp = (message: string) =>
  z.coerce.number().refine((value) => value >= 1000 && value <= 9999, {
    message,
  });
